export function isDeliveryVisitor(user: any): boolean {
  return !!(user && user.only_visitor && user.visitor_mode === "delivery");
}

const VISITOR_INVALIDATING_KEYS = new Set([
  "dinein_visitor_single_table_required",
  "visitor_session_expired",
  "visitor_session_mismatch",
  "visitor_dinein_not_enabled",
  "visitor_takeaway_not_enabled",
  "visitor_delivery_not_enabled",
  "invalid_visitor_session",
  "dinein_table_not_found",
]);

export function isVisitorInvalidatingCommentId(commentId: any): boolean {
  return (
    typeof commentId === "string" && VISITOR_INVALIDATING_KEYS.has(commentId)
  );
}

export function isVisitorOrderTypeConsistent(
  user: any,
  orderPickup: any,
  dineIn: any
): boolean {
  if (!user || !user.only_visitor) {
    return true;
  }
  if (user.visitor_mode === "dinein") {
    return dineIn === true && !orderPickup;
  }
  if (user.visitor_mode === "takeaway") {
    return orderPickup === true && !dineIn;
  }
  if (user.visitor_mode === "delivery") {
    return orderPickup === false && dineIn === false;
  }
  return false;
}

export function getDeliveryMethodAddressView(
  user: any
): "standard" | "restrictedVisitor" {
  if (isDeliveryVisitor(user)) {
    return "standard";
  }
  return user && (user.only_dinein || user.only_visitor)
    ? "restrictedVisitor"
    : "standard";
}

export function canUseDirectDeliveryStoreSelection(user: any): boolean {
  return !isDeliveryVisitor(user);
}

export function buildPreorderRequestData(user: any, selectedPreorderDate: any) {
  const preorderDate = isDeliveryVisitor(user) ? null : selectedPreorderDate;

  return {
    preorder: !!preorderDate,
    preorder_day: preorderDate && preorderDate.date ? preorderDate.date : "",
    preorder_time: preorderDate && preorderDate.hour ? preorderDate.hour : "",
  };
}
